import { Flex, Typography } from "antd";
import { CSSProperties, FC } from "react";
import { SvgIcon } from "src/components/icon";

interface Props {
  hint: string
  wrapperStyle?: CSSProperties
}

export const Hint: FC<Props> = ({ hint, wrapperStyle }) => {
  const styles: Record<string, CSSProperties> = {
    wrapper: {
      position: "relative",
      borderRadius: "16px",
      background: "#F8F8F8",
      padding: "24px",
      width: "100%",
      maxWidth: "306px",
      ...wrapperStyle
    },
    text: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: "#192126",
      margin: 0,
      whiteSpace: 'pre-line',
    }
  }

  return (
    <div style={styles.wrapper}>
      <Flex vertical gap={16}>
        <SvgIcon type={"lightBulb"} />

        <Typography.Paragraph style={styles.text}>
          {hint}
        </Typography.Paragraph>
      </Flex>
    </div>
  )
}